import client from './axios'

const gordonUsersApi = {
  list: (page, page_size) => {
    const config = {params:{}};
    if (page !== null) config.params.page = page;
    if (page_size !== null) config.params.page_size = page_size;

    return client.get('user/gordon/', config)
  },

  add: (username, password, role_id) => {
    return client.post('user/gordon/', { username, password, role_id })
  },

  edit: (userId, username, password, role_id) => {
    return client.put(`user/gordon/${userId}/`, { username, password, role_id })
  },

  delete: (userId) => {
    return client.delete(`user/gordon/${userId}/`)
  },

  export: () => {
    return client.get('user/gordon/export/')
  },

  roles: () => {
    return client.get('user/gordon/roles/')
  },
}

export default gordonUsersApi
